/** Alle Cube durch CUBE ersetzen**/
function replaceTextInElement(element) {
    if (element.nodeType === Node.TEXT_NODE) {
        element.textContent = element.textContent
            .replace(/Cube/g, "CUBE")
            .replace(/Ella/g, "ella");
    } else if (element.nodeType === Node.ELEMENT_NODE) {
        element.childNodes.forEach(replaceTextInElement);
    }
}

function rep() {
    const textElements = document.querySelectorAll('a, p, span, h1, h2, h3, h4, h5, h6');
    textElements.forEach(replaceTextInElement);
}

window.onload = rep;

if (!customElements.get('collapse-content')) {
  class CollapseContent extends HTMLElement {
    constructor() {
      super();
    }
    
    connectedCallback() {
      this.style.overflow = 'hidden';

      this.showCollapseButton();
      this.toggleButton.addEventListener('click', () => {
        this.toggleCollapsed();
      });
    }

    get isCollapsed() {
      return this.style.overflow === 'hidden';
    }

    get innerContent() {
      return this.querySelector('[collapse-content-inner]');
    }

    get toggleButtonContainer() {
      return this.querySelector('[collapse-content-toggle-container]');
    }
    get toggleButton() {
      return this.querySelector('[collapse-content-toggle]');
    }

    toggleCollapsed() {
      this.classList.toggle(this.dataset.expandedClass, this.isCollapsed);
      this.style.overflow = this.isCollapsed ? 'visible': 'hidden';
    }
    
    showCollapseButton() {
      if (this.innerContent.getBoundingClientRect().height > this.getBoundingClientRect().height) {
        this.toggleButtonContainer.removeAttribute('hidden');
      }
    }
  }
  customElements.define('collapse-content', CollapseContent);
}


var OrderstateForm = class extends HTMLFormElement {
  constructor() {
    super();

    this.els = this.getEls();

    this._onFormSubmitListener = this._onFormSubmitted.bind(this);
  }

  connectedCallback() {
    this.addEventListener('submit', this._onFormSubmitListener);
  }

  getEls() {
    return {
      ordernumberInput: this.querySelector('[name="ordernumber"'),
      zipcodeInput: this.querySelector('[name="zipcode"'),
      languageCodeInput: this.querySelector('[name="language_code"'),
      submitButton: this.querySelector('[type="submit"]'),
      errorMessage: this.querySelector('[data-error-message]'),
      successMessage: this.querySelector('[data-success-message]'),
      successMessageTemplateFulfilled: this.querySelector('[data-success-message-template-fulfilled]'),
      successMessageTemplateUnfulfilled: this.querySelector('[data-success-message-template-unfulfilled]')
    }
  }

  /**
   * Form Submit event handler
   */
  _onFormSubmitted(event) {
    event.preventDefault();
    const formData = new FormData(this);

    this._sendRequest({
      shopify_domain: window.themeVariables.settings.shopifyDomain,
      ordernumber: this.els.ordernumberInput.value,
      zipcode: this.els.zipcodeInput.value,
      language_code: this.els.languageCodeInput.value,
    });
  }

  /**
   * Sends data from the form
   */
  async _sendRequest(body) {
    this.els.errorMessage.hidden = true;

    try {
      const url = new URL('https://hiw2shopify.cube-store-brilon.de/bestellstatus/check/');
      const response = await fetch(url, {
        body: JSON.stringify(body),
        credentials: "same-origin",
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest"
        }
      });
      var responseBody = await response.json()
      //console.log("responseBody", responseBody);
      if(responseBody.type == "error") {
        this.els.errorMessage.hidden = false;
        this.els.successMessage.hidden = true;
      } else if (responseBody.type == "success") {
        let trackingUrl = "/pages/sendungsverfolgung?tracking-code=" + responseBody.data.lang + "~" + responseBody.data.trackingnumber + "~" + responseBody.data.zipcode + "~" + responseBody.data.ordernumber

        if(responseBody.data.orderstatus == "fulfilled") {
          let params = {
            "%ordernumber%": responseBody.data.ordernumber,
            "%trackingurl%": trackingUrl
          };

          this.els.successMessage.innerHTML = this.els.successMessageTemplateFulfilled.innerHTML.replace(/%\w+%/g, function(all) {
            return params[all] || all;
          });
        } else {
          let params = {
            "%ordernumber%": responseBody.data.ordernumber
          };

          this.els.successMessage.innerHTML = this.els.successMessageTemplateUnfulfilled.innerHTML.replace(/%\w+%/g, function(all) {
            return params[all] || all;
          });
        }


        this.els.errorMessage.hidden = true;
        this.els.successMessage.hidden = false;
      }

    } catch (err) {
      console.error(err);
      this.els.errorMessage.hidden = false;
      this.els.successMessage.hidden = true;
    }

    this.els.submitButton.setAttribute('aria-busy', 'false');
  }
}

if (!window.customElements.get("orderstate-form")) {
  window.customElements.define("orderstate-form", OrderstateForm, { extends: 'form' });
}
/** Variants Availability **/
class VariantsAvailability extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.updateVisibility();
    
    this.resizeObserver = new ResizeObserver(entries => {
      entries.forEach(entry => {
        const currentWidth = entry.contentRect.width;
        if (this.previousWidth !== undefined && this.previousWidth !== currentWidth) {
          this.previousWidth = currentWidth;
          this.updateVisibility();
        } else {
          this.previousWidth = currentWidth;
        }
      });
    });
    
    this.resizeObserver.observe(this);
  }

  disconnectedCallback() {
    this.resizeObserver.disconnect();
  }

  updateVisibility() {
    this.resetVisibility();
    const { width: containerWidth } = this.getBoundingClientRect();

    const totalAvailableVariantWidth = this.availableVariantEls.reduce((acc, el) => {
        const { width } = el.getBoundingClientRect();
        return acc + width + 4;
    }, 0);
    
    const totalAvailableSoonVariantWidth = this.availableSoonVariantEls.reduce((acc, el) => {
        const { width } = el.getBoundingClientRect();
        return acc + width + 4;
    }, 0);
  
    if (totalAvailableVariantWidth + totalAvailableSoonVariantWidth < containerWidth) {
        this.availableVariantEls.forEach(availableVariantEl => availableVariantEl.hidden = false);
        this.availableSoonVariantEls.forEach(availableSoonVariantEl => availableSoonVariantEl.hidden = false);
    } else if (totalAvailableVariantWidth < containerWidth) {
        this.availableVariantEls.forEach(availableVariantEl => availableVariantEl.hidden = false);
        this.availableSoonVariantEls.forEach(availableSoonVariantEl => availableSoonVariantEl.hidden = true);
    } else {
        this.availableVariantEls.forEach(availableVariantEl => availableVariantEl.hidden = true);
        this.availableSoonVariantEls.forEach(availableSoonVariantEl => availableSoonVariantEl.hidden = true);
        this.inStockEl.hidden = false;
    }
  }

  resetVisibility() {
    this.availableVariantEls.forEach(availableVariantEl => availableVariantEl.hidden = false);
    this.availableSoonVariantEls.forEach(availableSoonVariantEl => availableSoonVariantEl.hidden = false);
    this.inStockEl.hidden = true;
  }

  get availableVariantEls() {
    return [...this.querySelectorAll('[data-available-variant]')];
  }

  get availableSoonVariantEls() {
    return [...this.querySelectorAll('[data-available-soon-variant]')];
  }
  
  get inStockEl() {
    return this.querySelector('[data-in-stock]');
  }
  
  get inStockSoonEl() {
    return this.querySelector('[data-in-stock-soon]');
  }
}
if (!customElements.get('variants-availability')) {
  customElements.define('variants-availability', VariantsAvailability);
}
var NavigationTabs = class extends HTMLElement {
  constructor() {
    super();
    this.tabItems = this.getTabItems();
    this.tabSections = this.getTabSections();
    this.SCROLL_OFFSET = 80;
  }
  connectedCallback() {
    this.setSectionHeight();

    window.addEventListener('scroll', () => {
      this.setToFixed();
      this.setActiveTab();
    });

    this.addEventListener('click', (e) => {
      if (e.target.closest('.navigation-tabs__item')) {
        const sectionId = e.target.dataset.scrollToSection;
        this.scrollToSection(sectionId);
      }
    })
  }
  get section() {
    return this.closest('section');
  }
  getTabItems() {
    return [...this.querySelectorAll('[data-scroll-to-section]')].filter(tabItem => {
      const tabSectionExists = document.getElementById(tabItem.dataset.scrollToSection) !== null;
      if (!tabSectionExists) tabItem.setAttribute('hidden', '');

      return tabSectionExists;
    });
  }
  getTabSections() {
    return this.tabItems.map((tabItem) => {
      return document.getElementById(tabItem.dataset.scrollToSection);
    })
  }
  setSectionHeight() {
    const height = this.getBoundingClientRect().height;
    this.section.style.height = `${height}px`;
  }
  setToFixed() {
    const isFixed = this.section.getBoundingClientRect().top < 0;
    const footer = document.querySelector('footer'); // Referenz zum Footer-Element
    const footerTop = footer ? footer.getBoundingClientRect().top : Infinity; // Top-Position des Footers
    const shouldFixTabs = isFixed && footerTop > window.innerHeight;
  
    this.classList.toggle('navigation-tabs--fixed', shouldFixTabs);
  }
  setActiveTab() {
    let activeTabId;

    for (let i = 0; i < this.tabSections.length; i++) {
      const tabSectionEl = this.tabSections[i];
      const tabsHeight = this.getBoundingClientRect().height;
      const {top, height} = tabSectionEl.getBoundingClientRect();

      if (top < tabsHeight && top + height > tabsHeight) {
        activeTabId = tabSectionEl.id;
        break;
      }
    }
  }
  scrollToSection(sectionId) {
    const sectionEl = document.getElementById(sectionId);
    if (sectionEl) {
      const tabsHeight = this.getBoundingClientRect().height;
      const scrollTop = window.scrollY + sectionEl.getBoundingClientRect().top - tabsHeight + 1;

      window.scrollTo({
        top: scrollTop,
        behavior: 'smooth'
      });
    } else {
      console.warn(`No section with ID ${sectionId} found`);
    }
  }
};
if (!window.customElements.get("navigation-tabs")) {
  window.customElements.define("navigation-tabs", NavigationTabs);
}

class ProductConnector extends HTMLElement {
  constructor() {
    super();

    // Get references to the elements within the existing element
    this.spanElement = this.querySelector('[data-current-option]');
    this.aElements = this.querySelectorAll('a');

    // Capture the default text content
    this.defaultText = this.spanElement.textContent;

    // Add event listeners to the <a> elements
    this.aElements.forEach((a) => {
      a.addEventListener('mouseover', () => {
        // Change the textContent of the <span> element on hover
        this.spanElement.textContent = a.getAttribute('data-option');
      });

      a.addEventListener('mouseout', () => {
        // Reset the textContent of the <span> element to the default text
        this.spanElement.textContent = this.defaultText;
      });
    });
  }
}

// Register the custom element (if not already registered)
window.customElements.define('product-connector', ProductConnector);

class CountDownTimer extends HTMLElement {
  constructor() {
    super();
    this.endTime = new Date(this.getAttribute('data-enddate'));
    this.initialHtml = this.innerHTML;
    if (this.endTime != '') {
      this.init();
      this.startCountdown();
    }
  }

  init() {
    const today = new Date();
    let difference = this.endTime - today;
    const millisecondsInADay = 1000 * 60 * 60 * 24;
    this.days = Math.floor(difference / millisecondsInADay);
    const remainingMilliseconds = difference % millisecondsInADay;
    this.hours = Math.floor(remainingMilliseconds / (1000 * 60 * 60));
    this.minutes = Math.floor((remainingMilliseconds % (1000 * 60 * 60)) / (1000 * 60));
    this.seconds = Math.floor((remainingMilliseconds % (1000 * 60)) / 1000);
    this.innerHTML = this.getString(this.initialHtml);
    this.setAttribute('inited', true);
  }

  getString(replaceText) {
    const days = this.days;
    const hours = this.hours;
    const minutes = this.minutes;
    const seconds = this.seconds;

    replaceText = replaceText.replace(/\[dd\]/g, days);
    replaceText = replaceText.replace(/\[hh\]/g, hours);
    replaceText = replaceText.replace(/\[mm\]/g, minutes);
    replaceText = replaceText.replace(/\[ss\]/g, seconds);
    return replaceText;
  }

  startCountdown() {
    this.countdownInterval = setInterval(() => {
      if (this.days <= 0 && this.hours <= 0 && this.minutes <= 0 && this.seconds <= 0) {
        this.innerHTML = '';
        clearInterval(this.countdownInterval);        
        // Check if the timer is inside a div with the class shopify-section--announcement-bar
        const announcementBar = this.closest('.shopify-section--announcement-bar');
        if (announcementBar) {
          announcementBar.style.display = 'none';
        }
        const uspBar = document.querySelector('.usp-bar-wrapper');
        if (uspBar) {
          uspBar.removeAttribute('hidden');
        }
      } else {
        this.init();
      }
    }, 1000);
  }

  disconnectedCallback() {
    // Stop the interval when the element is removed
    clearInterval(this.countdownInterval);
  }
}

// Define the custom element
customElements.define('countdown-timer', CountDownTimer);


class CountDownTimerPrice extends HTMLElement {
  constructor() {
    super();
    this.endTime = new Date(this.getAttribute('data-enddate'));
    this.initialHtml = this.innerHTML;
    if (this.endTime != '') {
      this.init();
      this.startCountdown();
    }
  }

  init() {
    const today = new Date();
    let difference = this.endTime - today;
    const millisecondsInADay = 1000 * 60 * 60 * 24;
    this.daysinhours = Math.floor(difference / millisecondsInADay)*24;
    const remainingMilliseconds = difference % millisecondsInADay;
    this.hours = Math.floor(remainingMilliseconds / (1000 * 60 * 60))+this.daysinhours;
    this.minutes = Math.floor((remainingMilliseconds % (1000 * 60 * 60)) / (1000 * 60));
    this.seconds = Math.floor((remainingMilliseconds % (1000 * 60)) / 1000);
    this.innerHTML = this.getString(this.initialHtml);
    this.setAttribute('inited', true);
  }

  getString(replaceText) {
    const hours = this.hours;
    const minutes = String(this.minutes).padStart(2, '0');
    const seconds = String(this.seconds).padStart(2, '0');

    replaceText = replaceText.replace(/\[hh\]/g, hours);
    replaceText = replaceText.replace(/\[mm\]/g, minutes);
    replaceText = replaceText.replace(/\[ss\]/g, seconds);
    return replaceText;
  }

  startCountdown() {
    this.countdownInterval = setInterval(() => {
      if (this.hours <= 0 && this.minutes <= 0 && this.seconds <= 0) {
        this.innerHTML = '';
        clearInterval(this.countdownInterval);        
        // Check if the timer is inside a div with the class shopify-section--announcement-bar
        const announcementBar = this.closest('.shopify-section--announcement-bar');
        if (announcementBar) {
          announcementBar.style.display = 'none';
        }
        const uspBar = document.querySelector('.usp-bar-wrapper');
        if (uspBar) {
          uspBar.removeAttribute('hidden');
        }
      } else {
        this.init();
      }
    }, 1000);
  }

  disconnectedCallback() {
    // Stop the interval when the element is removed
    clearInterval(this.countdownInterval);
  }
}

// Define the custom element
customElements.define('countdown-timer-price', CountDownTimerPrice);

  /**
   * On Stock Badge
   */ 
  const renderOnStockBadge = (html) => {
    if (product.variants_inventory_count == 0) return '';

    return html`
        <variants-availability class="product-card__variant-availability">
          <span data-variant-href="${product.url}" class="product-card__variant product-card__variant--available" data-available-variant="">Auf Lager</span>
        <div class="product-card__variant product-card__variant--available" data-in-stock="" hidden="">Auf Lager</div></variants-availability>
    `;
  };

// Leasing Formular
document.addEventListener('DOMContentLoaded', function() {
    // Überprüft, ob das Dropdown für den Leasing-Anbieter existiert
    const leasingAnbieterSelect = document.querySelector('select[name="Leasing-Anbieter"]');
    if (leasingAnbieterSelect) {
        leasingAnbieterSelect.addEventListener('change', function() {
            const allDivs = document.querySelectorAll('div[data-leasing-partner-fields]');
            const selectedValue = this.value;
            allDivs.forEach(div => {
                if (div.id === selectedValue) {
                    div.removeAttribute('hidden');
                } else {
                    div.setAttribute('hidden', true);
                    div.querySelectorAll('input, select, textarea').forEach(field => field.value = '');
                }
            });
        });
    }

    // Überprüft, ob das Checkbox-Element für die Versandadresse existiert
    const checkbox = document.querySelector('[data-shipping-address-checkbox]');
    const shippingAddressContainer = document.querySelector('[data-shipping-address-container]');
    if (checkbox && shippingAddressContainer) {
        function toggleShippingAddressContainer() {
            if (checkbox.checked) {
                shippingAddressContainer.hidden = false;
            } else {
                shippingAddressContainer.hidden = true;
                shippingAddressContainer.querySelectorAll('input').forEach(input => input.value = '');
            }
        }
        checkbox.addEventListener('change', toggleShippingAddressContainer);
        toggleShippingAddressContainer();  // Initiale Überprüfung beim Laden der Seite
    }
});

/**
 * Financing Components
 */
var FinancingInfo = class extends HTMLElement {
  connectedCallback() {
    document.addEventListener('variant:change', ({detail}) => {
      this.fetchVariantInfo(detail.variant.id);
    });
  }

  async fetchVariantInfo(variantId) {
    const url = new URL(location.href);
    const sectionElement = this.closest(".shopify-section");
    if (sectionElement) {
      const sectionId = sectionElement.id.replace("shopify-section-", "");
      url.searchParams.set("variant", variantId);
      url.searchParams.set("section_id", sectionId);
    }

    const response = await fetch(url);
    const data = await response.text();
    const html = new DOMParser().parseFromString(data, 'text/html');

    const financingDrawerContentEl = html.getElementById('FinancingDrawerContent');
    const financingFromPriceEl = html.querySelector('[data-financing-from-price]');
    this.querySelector('#FinancingDrawerContent').innerHTML = financingDrawerContentEl.innerHTML;
    this.querySelector('[data-financing-from-price]').innerHTML = financingFromPriceEl.innerHTML;
  }
}
if (!window.customElements.get("financing-info")) {
  window.customElements.define("financing-info", FinancingInfo);
}

var FinancingRates = class extends HTMLElement {
  constructor() {
    super();
    this.els = this.getEls();
    this.config = this.getConfig();

    this.updateRatesListener = this.updateRates.bind(this);
  }

  connectedCallback() {
    document.addEventListener('listbox:select', this.updateRatesListener);
  }

  disconnectedCallback() {
    document.removeEventListener('listbox:select', this.updateRatesListener);
  }

  updateRates(event) {
    if (event.target.closest('#financing-rates')) {
      const { monthlyRate, borrowingRate, annualPercentageRate, finalPrice } = this.config.values[event.detail.value];

      this.els.monthlyRate.innerHTML = monthlyRate;
      this.els.borrowingRate.innerHTML = borrowingRate;
      this.els.annualPercentageRate.innerHTML = annualPercentageRate;
      this.els.finalPrice.innerHTML = finalPrice;
    }
  }

  getEls() {
    return {
      monthlyRate: this.querySelector('[data-monthly-rate]'),
      borrowingRate: this.querySelector('[data-borrowing-rate]'),
      annualPercentageRate: this.querySelector('[data-annual-percentage-rate]'),
      finalPrice: this.querySelector('[data-final-price]'),
    }
  }

  getConfig() {
    return JSON.parse(this.querySelector('[data-config]').innerText);
  }
}
if (!window.customElements.get("financing-rates")) {
  window.customElements.define("financing-rates", FinancingRates);
}

class InfinityScroll extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback(){
    this.init();
    this.scrollListener = () => this.handleScroll(); // Store the listener function reference
    document.addEventListener('scroll', this.scrollListener);

  }

  disconnectedCallback(){
    document.removeEventListener('scroll', this.scrollListener);
  }

  init(){
    this.loadMoreButton = this.querySelector('button');
    this.current = parseInt(this.getAttribute('data-current'));
    this.pages = JSON.parse(this.getAttribute('data-pages'));
    this.endPage = this.pages.slice(-1);
    this.pageData = {};
    this.loadingSoldOut = false;
    this.loadMoreButton.addEventListener('click', () => this.getProducts());
    this.scrollLoad = false;
    this.collectionContainer = document.querySelector('.collection product-list');
    this.language = JSON.parse(this.getAttribute('data-lang'));
  }

  handleScroll(){
    if(this.scrollLoad){
      if (this.isElementInViewport(this)) {
        this.getProducts();
        this.scrollLoad = false;
      }
    }
  }

  async getProducts() {
    this.loadMoreButton.textContent = this.language.loading;
    let current = this.current;
    let loadNumbers = this.pages.slice(0, 1);
    this.pages = this.pages.filter((_, i) => i >= 1);

    if (this.pages.length <= 0){
      this.setAttribute('hidden', true);
    }

    let tempDiv = document.createElement('div');
    let searchParams = new URL(window.location.href).searchParams;

    const queryParamsObject = {};
    for (const [key, value] of searchParams) {
      queryParamsObject[key] = value;
    }

    let productItemsContainer = document.createElement('div');

    //It was initially an array of 10 pages because i misunderstood the task
    //But ill leave it cuz it works and also can be used with await if wished to expand its function

    for (const i of loadNumbers){
      this.current++;
      queryParamsObject.page = this.current;
      let fetchURl = this.getURLBase() + '?' + this.createQueryString(queryParamsObject);
      let data = await this.getCollectionData(fetchURl);
      let productItems = data.targets.querySelectorAll('product-card');

      productItems.forEach((item) => {
        this.collectionContainer.append(item);
        if(item.hasAttribute('sold-out')){
          this.scrollLoad = false;
          this.loadMoreButton.textContent = this.language.load_more;
          this.loadingSoldOut = true;

        }else{
          this.scrollLoad = true;
        }
      })

      if (this.current >= this.endPage){
        this.setAttribute('hidden', true);
        return;
      }
    }

    //Keeping this in case the logic reverts
    if (this.current % 10 === 0) {
      this.scrollLoad = false;
      this.loadMoreButton.textContent = this.language.load_more;
    }else{
      this.scrollLoad = true;
    }
  }
  async getCollectionData(fetchURL) {
    try {
      const response = await fetch(fetchURL);
      const html = await response.text();
      let tempDiv = document.createElement('div');
      tempDiv.innerHTML = html;
      let targets = tempDiv.querySelector('[data-infinity-target]');
      return {
        targets: targets
      };
    } catch (error) {
      console.error('Error fetching data:', error);
      return {
        targets: null
      };
    }
  }

  getURLBase(){
    return location.protocol + '//' + location.host + location.pathname;
  }

  createQueryString(params) {
    const queryString = Object.keys(params)
            .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
            .join('&');
    return queryString;
  }

  isElementInViewport(el) {
    const rect = el.getBoundingClientRect();
    return (
            rect.top >= 0 &&
            rect.left >= 0 &&
            rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
            rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
  }
}
window.customElements.define("infinity-scroll", InfinityScroll);


const product_gallery = document.querySelector('.product-gallery');
if (product_gallery) {
    const distanceFromTop = product_gallery.getBoundingClientRect().top;
    const distanceFromDocumentTop = window.scrollY + distanceFromTop;
    product_gallery.style.top = `${distanceFromDocumentTop}px`;
}